export default {
  sideMenu: {
    main: "主頁",
    home: "首頁",
    login: "登錄頁",
    authority_server:"認證服務",
    authority_management: "許可權相關",
    user_management: "成員管理",
    organization_management: "組織管理",
    resource_management: "資源管理",
    role_management: "資源分組",
  },
  common: {
    invalidForm:"表單校驗失敗",
    invalidPhone: "手機號碼格式不正確",
    invalidVerifyCode: "驗證碼格式不正確",
    onlyone:"新增名稱不能重複",
    action:'操作',
    close:"關閉",
    cardType1: "內地身份證",
    cardType2: "香港身份證",
    cardType3: "澳門身份證",
    cardType4: "其他證件/證照",
    name: "姓名",
    ID: "ID",
    email: "郵箱",
    position: "崗位",
    exportMemeber: "導出成員",
    exportResource: "導出資源",
    addOrg: "新增機構",
    orgList: "機構列表",
    place: "地區",
    forbid: "停用",
    normal: "正常",
    cancel: "取消",
    status: "狀態",
    selectDate: "選擇日期",
    inputKey: "輸入ID/名稱搜索",
    loginTitle: "商城管理平台臺",
    pleaseInput: "請輸入",
    pleaseSelect: "請選擇",
    query: "查詢",
    add: "新增",
    edit: "編輯",
    remove: "刪除",
    connectResourceGroup: "關聯資源分組",
    addOrgorPo: "新增部門或崗位",
    toTop: "置頂",
    exportMember: "導出人員",
    uploadResource: "資源上傳",
    resourceExport: "資源導出",
    alert: "警告",
    connectResource: "關聯資源",
    remark: "備註",
    confirmEdit: "確認要進行修改嗎？",
    myCollection:"我的收藏",
    addtoCollection:"點擊添加功能到我的收藏",
    myCollectionSetting:"我的收藏配置",
    notice: "公告",
    currentTime:"當前時間",
    collectedList:"已收藏的功能列表",
    delete:"刪除",
    primaryDirectory:"一級目錄",
    functionName:"功能名稱",
    functionNameQuery:"輸入功能名稱查詢",
    selectGrouptoAdd:"請選擇要新增的功能分組",
    maxFunction:"我的收藏最多可以存放N個功能",
    confirm:"確定",
    msg:"消息",
    confirmDelete:"確認要進行刪除操作嗎，該操作",
    unrecoverable:"不可恢復",
    associatedPhone: "關聯手機號",
    unbind: "取消關聯",
    queryPhone: "查看手機號",
    addSuccess: "添加成功",
    index: "序號",
    phoneRepeated: "手機號不能重複"
  },
  login: {
    org: "機構號",
    userName: "用戶名",
    passwords: "密碼",
    login: "登錄",
    locked: "已鎖定",
    verifyCode: "驗證碼",
    getVerifyCode: "發送驗證碼",
    copyRight: "© 版權所有QCC 版本號：CAKU V1.00",
  },
  timeZone: "8", //時區
  message: {
    hello: "好好學習，天天向上！",
  },
  authorization: {
    addMember: "添加成員",
    editMember: "編輯成員",
    addresource: "添加資源",
    editresource: "編輯資源",
    addresourceGroup: "添加資源組",
    editresourceGroup: "編輯資源組",
    addPhone: "添加手機號",
    member: {
      name: "Name",
      userId: "用戶ID",
      userName: "用戶姓名",
      userKind: "用戶類別",
      userRole: "用戶角色",
      lastUpdater: "最後更新者",
      lastUpdateTime: "最後更新時間",
      rootOrgCode: "一級組織機構號",
      parentOrgCode: "父級組織機構號",
      branchCode: "分支行號",
      contactNo: "聯繫電話",
      email: "電子郵箱",
      positionCodes: "用戶崗位",
      loginPwd: "登陸密碼",
      effectiveDate: "密碼生效時間",
      pwdExpDate: "密碼過期時間",
      addMemeberTitle: "新增成員",
      editMemeberTitle: "編輯成員",
      addTitle: "新增",
      connectResourceGroup: "關聯資源分組",
      onlyChooseOne: "只能選擇一項編輯！",
      mustChooseOne: "必須選擇一項！",
      loginId: "登錄ID",
      ID: "ID",
      job: "崗位",
      basicInfo: "基礎資訊",
      loginInfo: "登錄資訊",
      phoneInfo: "手機號資訊",
      positionRule: "多個崗位時，用”,”分割。Eg:code1,code2,code3",
      lengthRule: "長度限制16，其他待補充",
      loginPwdRule: "待補充",
      effectiveDateRule: "yyyy-MM-dd HH:mm:ss 不得大於過期時間",
      pwdExpDateRule: "yyyy-MM-dd HH:mm:ss",
    },
    organization: {
      code: "編碼",
      type: "類型",
      department: "部門",
      organization: "組織",
      positionType: "崗位類型",
      position: "崗位",
      phone: "固定電話",
      orgCode: "機構編碼",
      engName: "英文名稱",
      chName: "中文名稱",
      selectProvince: "請選擇省份",
      selectCity: "請選擇城市",
      selectArea: "請選擇區縣",
      placeDetail: "詳細地址",
      selectAddType: "請選擇新增類別",
      positionCode: "崗位編碼",
      sequence: "順序號",
      name: "姓名",
      ID: "ID",
      email: "郵箱",
      confirmDelete1: "確認要進行刪除操作嗎，該操作",
      confirmDelete2: "不可恢復",
      selectResGroup: "請選擇要新增的資源分組",
      selectAddorInput: "請選擇要新增子組織或崗位並在下方輸入名稱",
      childOrg: "子組織",
      inputAddOrg: "請輸入新增的組織名稱",
      inputOrg: "請在此輸入組織名稱",
      connectedGroup: "已關聯資源分組列表",
      resGroupCode: "資源分組編碼",
    },
    resource: {
      icon:"圖示",
      urlName: "URL名稱",
      module: "模組",
      group: "分組",
      menu: "菜單",
      button: "按鈕",
      dataAuth: "數據許可權",
      urlAuth: "url請求許可權",
      resCode: "資源編碼",
      onlyCodeRule:
        "唯一資源編碼，以字母開頭，可以填寫數字、字母、下劃線（例如：resource_page_1）",
      resName: "資源名稱",
      resNameCn: "資源中文名稱",
      belongSys: "所屬系統",
      resType: "資源類型",
      status: "資源狀態",
      resSequence: "順序號",
      resContent: "資源內容",
      moduleText: "模組說明",
      urlList: "關聯url",
      addResTitle: "新增資源",
      editResTitle: "編輯資源",
      area1: "區域一",
      area2: "區域二",
      upload: "上傳到伺服器",
      uploadRule: "只能上傳excel檔",
      exportRes: "導出資源",
    },
    resGroup: {
      connectRes: "關聯資源",
      resGroupCode: "資源分組編碼",
      resGroupName: "資源分組名稱",
      resGroupNameCn: "資源分組中文名稱",
      belongSys: "所屬系統",
      belongOrg: "所屬機構",
      effectiveDate: "生效時間",
      expDate: "失效時間",
      name: "名稱",
      addResGroup: "新增資源分組",
      editResGroup: "編輯資源分組",
      onlyConnect: "只能選擇一條關聯",
    },
  },
  header: {
    switchLang: "切換語言",
    myTable: "我的工作臺",
    center: "處理中心",
    logout: "登出",
    mainPage:"主頁"
  },
  pages: {},
};
